"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createKey = void 0;
var _changeCase = require("change-case");
const createKey = function () {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return params.filter(param => !!param).map(param => (0, _changeCase.paramCase)(param + '')).join('-');
};
exports.createKey = createKey;
//# sourceMappingURL=key.js.map